var _path, _ellipse, _line, _line2, _line3, _line4, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _rect, _path10, _path11, _path12, _rect2, _path13, _path14, _path15, _circle, _rect3, _line5, _line6, _circle2, _tspan, _path16, _path17, _path18, _path19, _path20, _rect4, _rect5, _rect6, _rect7, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _circle3, _path29, _circle4, _ellipse2, _ellipse3, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _rect8, _path39, _rect9, _rect10, _rect11, _path40, _circle5, _rect12;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLoginImage(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 575.254,
    height: 403.712,
    viewBox: "0 0 575.254 403.712",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_2191",
    "data-name": "Grupo 2191",
    transform: "translate(-1953.349 -113.707)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_3411",
    "data-name": "Trazado 3411",
    d: "M2286.536,113.944c57.959-.405,53.7,30.81,121.083,62.218s128.18,16.817,142.366,73.155c.405,130.1-66.267,104.023-151.179,175.5-80.728,67.952-148.342,97.273-186.846,92s-160.1-79.845-144.289-245.616C2090.368,125.293,2191.694,111.513,2286.536,113.944Z",
    transform: "translate(-21.384 0)",
    fill: "#ade0d9"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    id: "Elipse_52",
    "data-name": "Elipse 52",
    cx: 51.158,
    cy: 11.308,
    rx: 51.158,
    ry: 11.308,
    transform: "translate(2171.344 384.311)",
    fill: "#07274a"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    id: "L\\xEDnea_144",
    "data-name": "L\\xEDnea 144",
    x1: 28.736,
    y2: 89.937,
    transform: "translate(2193.766 395.619)",
    fill: "#07274a",
    stroke: "#07274a",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 3
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    id: "L\\xEDnea_145",
    "data-name": "L\\xEDnea 145",
    x2: 28.736,
    y2: 89.937,
    transform: "translate(2222.502 395.619)",
    fill: "#07274a",
    stroke: "#07274a",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 3
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    id: "L\\xEDnea_146",
    "data-name": "L\\xEDnea 146",
    y1: 20.541,
    x2: 32.035,
    transform: "translate(2203.201 435.485)",
    fill: "#07274a",
    stroke: "#07274a",
    strokeMiterlimit: 10,
    strokeWidth: 1
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    id: "L\\xEDnea_147",
    "data-name": "L\\xEDnea 147",
    x2: 32.044,
    y2: 20.541,
    transform: "translate(2209.638 435.485)",
    fill: "#07274a",
    stroke: "#07274a",
    strokeMiterlimit: 10,
    strokeWidth: 1
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_3412",
    "data-name": "Trazado 3412",
    d: "M2347.326,341.384c-.13,3.988-.073,17.955-.73,23.929",
    transform: "translate(-74.476 -43.119)",
    fill: "none",
    stroke: "#1f161e",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_3413",
    "data-name": "Trazado 3413",
    d: "M2557.726,317.2h4.864a1.937,1.937,0,0,0,1.929-1.929v-29.9a1.906,1.906,0,0,0-.568-1.362l-6.145-6.144a1.921,1.921,0,0,0-1.362-.567H2538.3a1.937,1.937,0,0,0-1.929,1.929v2.886",
    transform: "translate(-110.416 -30.983)",
    fill: "#fbdc8e"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_3414",
    "data-name": "Trazado 3414",
    d: "M2034.6,414.5c15.4,2.918,12.654,94.842-16.909,89.281C1989.77,498.479,2015.807,410.924,2034.6,414.5Z",
    transform: "translate(-9.868 -56.946)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_3415",
    "data-name": "Trazado 3415",
    d: "M1957.108,428.4c12.256-6.939,63.56,57.618,40.093,70.9C1975.03,511.9,1942.184,436.865,1957.108,428.4Z",
    transform: "translate(0 -59.501)",
    fill: "#07274a"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_3416",
    "data-name": "Trazado 3416",
    d: "M2025.708,568.869h-30.949a5.067,5.067,0,0,1-5.034-4.507l-3.907-35.083a5.075,5.075,0,0,1,5.034-5.674h38.6a5.066,5.066,0,0,1,5.063,5.07,4.977,4.977,0,0,1-.029.54L2030.75,564.3A5.074,5.074,0,0,1,2025.708,568.869Z",
    transform: "translate(-6.142 -77.63)",
    fill: "#969696"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_3417",
    "data-name": "Trazado 3417",
    d: "M2045.683,370.32c11.73,3.4,2.74,74.357-19.722,67.824C2004.755,431.983,2031.408,366.17,2045.683,370.32Z",
    transform: "translate(-12.256 -48.564)",
    fill: "#176385"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_3418",
    "data-name": "Trazado 3418",
    d: "M2065.865,439.746c8.106,6.987-24.87,60.439-40.45,47.016C2010.7,474.14,2055.967,431.251,2065.865,439.746Z",
    transform: "translate(-13.096 -61.539)",
    fill: "#07274a"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_3419",
    "data-name": "Trazado 3419",
    d: "M2011.347,379.464c17.558,0,33.632,112.108,0,112.108C1979.587,491.572,1989.971,379.464,2011.347,379.464Z",
    transform: "translate(-7.175 -50.331)",
    fill: "#00af9a"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_2419",
    "data-name": "Rect\\xE1ngulo 2419",
    width: 68.335,
    height: 12.548,
    rx: 4.05,
    transform: "translate(1969.932 438.387)",
    fill: "#d8d8d8"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_3420",
    "data-name": "Trazado 3420",
    d: "M2547.962,283.244h-17.833a2.173,2.173,0,0,0-2.173,2.172v35.513a2.18,2.18,0,0,0,2.173,2.181h23.824a2.18,2.18,0,0,0,2.173-2.181V291.423a2.173,2.173,0,0,0-.632-1.54l-6-6A2.174,2.174,0,0,0,2547.962,283.244Z",
    transform: "translate(-108.823 -32.108)",
    fill: "#e5e5e5"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_3421",
    "data-name": "Trazado 3421",
    d: "M2561.017,290.572h-6.055a1.216,1.216,0,0,1-1.216-1.216v-6.112",
    transform: "translate(-113.708 -32.108)",
    fill: "#969696"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_3422",
    "data-name": "Trazado 3422",
    d: "M2569.425,284.64h-6.055a1.231,1.231,0,0,1-1.224-1.224V277.3",
    transform: "translate(-115.299 -30.983)",
    fill: "#00af9a"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_2420",
    "data-name": "Rect\\xE1ngulo 2420",
    width: 46.707,
    height: 18.563,
    rx: 3.03,
    transform: "translate(2374.906 210.548)",
    fill: "#00af9a"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_3423",
    "data-name": "Trazado 3423",
    d: "M2500.882,267.793l5.626-17.039h-11.251Z",
    transform: "translate(-102.631 -25.955)",
    fill: "#00af9a"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_3424",
    "data-name": "Trazado 3424",
    d: "M2487.344,239.274l-4.718,8.163h9.427Z",
    transform: "translate(-100.239 -23.781)",
    fill: "#fff"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_3425",
    "data-name": "Trazado 3425",
    d: "M2514.854,247.437l4.718-8.163h-9.435Z",
    transform: "translate(-105.449 -23.781)",
    fill: "#fff"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_53",
    "data-name": "Elipse 53",
    cx: 3.542,
    cy: 3.542,
    r: 3.542,
    transform: "translate(2394.708 216.036)",
    fill: "#fff"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_2421",
    "data-name": "Rect\\xE1ngulo 2421",
    width: 31.727,
    height: 20.881,
    rx: 2.65,
    transform: "translate(2365.032 171.209)",
    fill: "#e5e5e5"
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    id: "L\\xEDnea_148",
    "data-name": "L\\xEDnea 148",
    x2: 14.867,
    y2: 9.784,
    transform: "translate(2366.029 171.866)",
    fill: "none",
    stroke: "#969696",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.82
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    id: "L\\xEDnea_149",
    "data-name": "L\\xEDnea 149",
    x1: 15.864,
    y2: 10.441,
    transform: "translate(2380.896 171.209)",
    fill: "none",
    stroke: "#969696",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.82
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_54",
    "data-name": "Elipse 54",
    cx: 4.539,
    cy: 4.539,
    r: 4.539,
    transform: "translate(2392.22 166.67)",
    fill: "#176385"
  })), /*#__PURE__*/React.createElement("text", {
    id: "_1",
    "data-name": 1,
    transform: "translate(2395.446 171.286)",
    fill: "#fff",
    fontSize: 4,
    fontFamily: "Arial-BoldMT, Arial",
    fontWeight: 700,
    style: {
      isolation: "isolate"
    }
  }, _tspan || (_tspan = /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "1"))), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_3426",
    "data-name": "Trazado 3426",
    d: "M2532.648,287.764h5.739a.762.762,0,0,1,.762.762h0a.762.762,0,0,1-.762.762h-5.739a.762.762,0,0,1-.762-.762h0A.762.762,0,0,1,2532.648,287.764Z",
    transform: "translate(-109.568 -32.964)",
    fill: "#969696"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_3427",
    "data-name": "Trazado 3427",
    d: "M2532.648,292.284h5.739a.762.762,0,0,1,.762.762h0a.762.762,0,0,1-.762.762h-5.739a.762.762,0,0,1-.762-.762h0A.762.762,0,0,1,2532.648,292.284Z",
    transform: "translate(-109.568 -33.82)",
    fill: "#969696"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_3428",
    "data-name": "Trazado 3428",
    d: "M2532.238,300.014h20.955a.762.762,0,0,1,.762.762h0a.762.762,0,0,1-.762.762h-20.955a.762.762,0,0,1-.762-.762h0A.762.762,0,0,1,2532.238,300.014Z",
    transform: "translate(-109.49 -35.284)",
    fill: "#969696"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_3429",
    "data-name": "Trazado 3429",
    d: "M2532.238,304.454h20.955a.762.762,0,0,1,.762.762h0a.762.762,0,0,1-.762.762h-20.955a.762.762,0,0,1-.762-.762h0A.762.762,0,0,1,2532.238,304.454Z",
    transform: "translate(-109.49 -36.125)",
    fill: "#969696"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_3430",
    "data-name": "Trazado 3430",
    d: "M2532.238,308.894h20.955a.762.762,0,0,1,.762.762h0a.762.762,0,0,1-.762.762h-20.955a.762.762,0,0,1-.762-.762h0A.762.762,0,0,1,2532.238,308.894Z",
    transform: "translate(-109.49 -36.966)",
    fill: "#969696"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_2422",
    "data-name": "Rect\\xE1ngulo 2422",
    width: 49.05,
    height: 33.892,
    rx: 12,
    transform: "translate(2299.591 189.197)",
    fill: "#e5e5e5"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_2423",
    "data-name": "Rect\\xE1ngulo 2423",
    width: 7.377,
    height: 22.981,
    transform: "translate(2309.74 194.652)",
    fill: "#00af9a"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_2424",
    "data-name": "Rect\\xE1ngulo 2424",
    width: 7.377,
    height: 7.701,
    transform: "translate(2320.432 209.94)",
    fill: "#00af9a"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_2425",
    "data-name": "Rect\\xE1ngulo 2425",
    width: 7.377,
    height: 14.178,
    transform: "translate(2331.116 203.456)",
    fill: "#00af9a"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_3431",
    "data-name": "Trazado 3431",
    d: "M2438.47,559.2c0,1.921-1.127,14.04,1.119,15.158s26.928,1.8,28.047.673,1.792-3.478.811-4.15-10.538-2.578-11.835-3.478-3.088-5.674-2.432-8.2",
    transform: "translate(-91.822 -84.372)",
    fill: "#07274a"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_3432",
    "data-name": "Trazado 3432",
    d: "M2319.688,340.224l13.894-4.985c-.6-25.348-6.526-81.985-14.94-90.408-1.978-1.97-41.1-5.407-48.077-5.407-41.649,0-54,4.75-57.14,7.9-9.727,9.727-12.759,54.8-12.759,70.58s44.584,23.97,44.584,23.97l52.26,3.591s11.462,1.183,21.376,1.767C2319.1,344.188,2319.688,340.224,2319.688,340.224Z",
    transform: "translate(-46.839 -23.809)",
    fill: "#00af9a"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_3433",
    "data-name": "Trazado 3433",
    d: "M2398.566,381.131c3.8-1.127,41.609-7.3,49.844.811s34.159,124.324,34.159,127H2461.7L2433.52,448.3",
    transform: "translate(-84.319 -50.021)",
    fill: "#07274a"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_3434",
    "data-name": "Trazado 3434",
    d: "M2227.2,368.961c-.948,4.742-6.647,9.833-6.647,35.667,0,35.724,29.263,36.478,39.769,36.478,32.733,0,85.69-9.727,89.265-11.511,2.375,3.972,46.091,93.22,46.294,95.215h20.128s-12.476-133.524-34.986-148.666C2373.713,371.279,2243.991,366.075,2227.2,368.961Z",
    transform: "translate(-50.606 -48.185)",
    fill: "#176385"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_3435",
    "data-name": "Trazado 3435",
    d: "M2368.961,336.934c-5.285,0-9.646,1.256-21.611,3.607l-.624,22.892c11.348-4.572,13.983-10.927,17.274-10.927,8.22,0,12.516,4.24,17.372,4.24,3.388,0,9.484-2.659,9.484-6.274C2390.856,342.9,2375.511,336.934,2368.961,336.934Z",
    transform: "translate(-74.501 -42.277)",
    fill: "#f8cdba"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_3436",
    "data-name": "Trazado 3436",
    d: "M2477.84,537.594c0,1.929-1.126,14.04,1.119,15.167s26.929,1.791,28.047.673,1.792-3.478.811-4.15-10.538-2.586-11.835-3.486-3.088-5.674-2.432-8.2",
    transform: "translate(-99.278 -80.279)",
    fill: "#07274a"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_3437",
    "data-name": "Trazado 3437",
    d: "M2291.841,240.267c0,3.056-17.745,3.145-17.745,0V215.414h17.745Z",
    transform: "translate(-60.746 -19.262)",
    fill: "#f8cdba"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_3438",
    "data-name": "Trazado 3438",
    d: "M2286.061,224.037c-1.621,0-11.965,4.572-11.965,7.125V217.674C2276.674,217.674,2286.061,224.037,2286.061,224.037Z",
    transform: "translate(-60.746 -19.69)",
    fill: "#1f161e"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_55",
    "data-name": "Elipse 55",
    cx: 21.481,
    cy: 21.481,
    r: 21.481,
    transform: "translate(2207.262 162.439)",
    fill: "#f8cdba"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_3439",
    "data-name": "Trazado 3439",
    d: "M2309.056,174.513c-2.659,4.223-8.22,6.161-14.243,6.161-5.131,0-12.6-1.492-17.922,1.54-2.878,1.621-6.177,5.31-6.842,12.694,0,1.265-1.435,6.169-1.435,7.749,0,1.078-1.216,1.783-3.242,1.783-1.045,0-3.113-1.694-3.113-4.28,0-2.991,1.192-4.053,1.192-6.59s-3.1-4.977-3.1-12.029c0-10.157,6.485-16.415,11.073-16.415,4.183,0,5.5.973,6.023,1.386,0-9.233,12.159-13.448,16.982-13.448,5.512,0,8.106,2.262,8.106,5.139,0,4.588-2.188,8.487-3.3,9.363a13.617,13.617,0,0,1,9.16-3.494c6.315,0,8.438,4.15,8.438,6.987,0,6.169-7.4,11.884-10.157,11.884a29.471,29.471,0,0,0-2.432-4.207",
    transform: "translate(-58.142 -7.454)",
    fill: "#1f161e"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_56",
    "data-name": "Elipse 56",
    cx: 4.58,
    cy: 4.58,
    r: 4.58,
    transform: "translate(2207.992 182.177)",
    fill: "#f8cdba"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    id: "Elipse_57",
    "data-name": "Elipse 57",
    cx: 3.55,
    cy: 1.848,
    rx: 3.55,
    ry: 1.848,
    transform: "translate(2246.885 184.163)",
    fill: "#fa9e9f"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    id: "Elipse_58",
    "data-name": "Elipse 58",
    cx: 3.55,
    cy: 1.848,
    rx: 3.55,
    ry: 1.848,
    transform: "translate(2224.553 184.163)",
    fill: "#fa9e9f"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_3440",
    "data-name": "Trazado 3440",
    d: "M2309.146,198.174c.665.948,4.053,4.929.478,6.542",
    transform: "translate(-67.384 -15.997)",
    fill: "none",
    stroke: "#1f161e",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_3441",
    "data-name": "Trazado 3441",
    d: "M2300.069,211.385c-1.07,0-2.715-1.329-3.583-2.521",
    transform: "translate(-64.986 -18.022)",
    fill: "none",
    stroke: "#1f161e",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_3442",
    "data-name": "Trazado 3442",
    d: "M2335.846,283.144c1.621,3.445,9.444,36.68,9.444,47.21",
    transform: "translate(-72.44 -32.089)",
    fill: "none",
    stroke: "#1f161e",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_3443",
    "data-name": "Trazado 3443",
    d: "M2200.666,332.934c0,37.361.349,48.2,15.345,48.2,34.564,0,86.816-28.371,96.13-28.371,8.228,0,12.524,4.248,17.379,4.248,3.38,0,9.476-2.667,9.476-6.274,0-7.579-15.345-13.545-21.886-13.545-14.729,0-73.506,14.2-74.941,14.2s-3.851-.624-3.851-3.04c0-4.385,2.87-14.518,3.242-15.4Z",
    transform: "translate(-46.839 -41.519)",
    fill: "#f8cdba"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_3444",
    "data-name": "Trazado 3444",
    d: "M2259.525,292.734c-.989,2.845-8.7,32.246-9.59,35.829",
    transform: "translate(-56.17 -33.906)",
    fill: "none",
    stroke: "#1f161e",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_3445",
    "data-name": "Trazado 3445",
    d: "M2618.145,538.131h0a4.151,4.151,0,0,1-5.07-2.959l-41.5-157.861a4.15,4.15,0,0,1,2.958-5.069h0a4.151,4.151,0,0,1,5.07,2.959l41.5,157.86A4.151,4.151,0,0,1,2618.145,538.131Z",
    transform: "translate(-117.058 -48.938)",
    fill: "#969696"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_3446",
    "data-name": "Trazado 3446",
    d: "M2556.534,372.251h0a4.15,4.15,0,0,1,2.958,5.07l-41.5,157.86a4.15,4.15,0,0,1-5.069,2.959h0a4.15,4.15,0,0,1-2.958-5.07l41.5-157.86A4.15,4.15,0,0,1,2556.534,372.251Z",
    transform: "translate(-105.39 -48.939)",
    fill: "#969696"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_3447",
    "data-name": "Trazado 3447",
    d: "M2485.886,372.25h0a4.151,4.151,0,0,1,2.958,5.07l-41.5,157.86a4.15,4.15,0,0,1-5.07,2.959h0a4.15,4.15,0,0,1-2.959-5.069l41.5-157.86A4.151,4.151,0,0,1,2485.886,372.25Z",
    transform: "translate(-92.01 -48.939)",
    fill: "#d8d8d8"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_3448",
    "data-name": "Trazado 3448",
    d: "M2546.764,534.46h0a4.158,4.158,0,0,1-5.064-2.989l-40.806-158.328a4.158,4.158,0,0,1,2.989-5.063h0a4.157,4.157,0,0,1,5.063,2.988L2549.752,529.4A4.158,4.158,0,0,1,2546.764,534.46Z",
    transform: "translate(-103.673 -48.15)",
    fill: "#d8d8d8"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_2426",
    "data-name": "Rect\\xE1ngulo 2426",
    width: 171.526,
    height: 8.301,
    rx: 4.15,
    transform: "matrix(0.254, -0.967, 0.967, 0.254, 2112.451, 488.148)",
    fill: "#969696"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_3449",
    "data-name": "Trazado 3449",
    d: "M2258.206,538.143h0a4.15,4.15,0,0,1-5.069-2.959l-41.5-157.86a4.15,4.15,0,0,1,2.959-5.07h0a4.151,4.151,0,0,1,5.07,2.959l41.5,157.861A4.15,4.15,0,0,1,2258.206,538.143Z",
    transform: "translate(-48.89 -48.94)",
    fill: "#969696"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_2427",
    "data-name": "Rect\\xE1ngulo 2427",
    width: 408.735,
    height: 12.281,
    rx: 4.53,
    transform: "translate(2074.59 315.515)",
    fill: "#d8d8d8"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_2428",
    "data-name": "Rect\\xE1ngulo 2428",
    width: 171.526,
    height: 8.301,
    rx: 4.15,
    transform: "matrix(0.254, -0.967, 0.967, 0.254, 2053.135, 488.151)",
    fill: "#d8d8d8"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_2429",
    "data-name": "Rect\\xE1ngulo 2429",
    width: 8.301,
    height: 171.526,
    rx: 4.15,
    transform: "matrix(0.967, -0.254, 0.254, 0.967, 2102.372, 324.371)",
    fill: "#d8d8d8"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_3450",
    "data-name": "Trazado 3450",
    d: "M2456.106,350.84h-74.99l13.586-46.724a5.455,5.455,0,0,1,5.253-3.883h63.633a5.365,5.365,0,0,1,5.253,6.817Z",
    transform: "translate(-81.014 -35.326)",
    fill: "#969696"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_59",
    "data-name": "Elipse 59",
    cx: 4.588,
    cy: 4.588,
    r: 4.588,
    transform: "translate(2342.213 285.619)",
    fill: "#fff"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_2430",
    "data-name": "Rect\\xE1ngulo 2430",
    width: 52.617,
    height: 3.283,
    transform: "translate(2256.394 312.232)",
    fill: "#969696"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoginImage);
export default __webpack_public_path__ + "static/media/login_image.366456eb66fc2c63042d4950b22e26e6.svg";
export { ForwardRef as ReactComponent };